
import { defineComponent, onMounted } from "vue"
import OfferNavigationBar from "@/components/OfferNavigationBar.vue"
import Banner from "@/components/Banner.vue"
import FooterSection from "@/components/FooterSection.vue"
import { useStore } from "vuex";
import { OfferActionTypes } from "@/store/Interfaces/Offer/IOfferAction";


export default defineComponent({
  components: { OfferNavigationBar, Banner, FooterSection},
  name: "App",

  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(OfferActionTypes.InitializeLanguage);
    })
  },
});
